var PubSub = require('pubsub-js');

(function ($) {
  'use strict';

  /**
   * Dynamically resize a component sized in ems based on its parent's width
   */
  class FitText {
    constructor () {
      this.$fitTextElems = $('.js-fit-text');
      this.resize();
      PubSub.subscribe('windowResized', $.proxy(this.resize, this));
    }

    resize () {
      this.$fitTextElems.each((i, elem) => {
        let elemWidth = $(elem).data('fit-text-width');
        let $elemWrapper = $(elem).parent();
        $(elem).css('font-size', $elemWrapper.width() / elemWidth + 'px');
      });
    }
  }

  this.FitText = FitText;
}).call(Framework, jQuery);
